<template>
  <el-dialog class="set-body" :class="{'nop-body':dialogConfig.noPadding}" :visible="open"
             :title="getTitle(title)" v-bind="dialogConfig" :before-close="cancel" draggable="false">
    <component v-if="open" :fromType="fromType" :is="mode" v-bind="propsData"
               @cancel="cancel" @refresh="refresh" @backProp="backProp" @setTitle="setTitle"></component>
  </el-dialog>
</template>

<script>
/**
 * @description 弹窗二次封装（element-ui=>el-dialog）
 * @example
 this.$refs.common.init({
         modeVal: PersonalDetail,
         tit: '标题',
         config: { width: '60%' },
          fromType: 'View',
          propsData: { personId: this.form.personId },
      });
 * @param {function} init(modeVal,params,tit,config,fromType,propsData)
 * @param init => {model} modeVal: 引入的弹窗模块，传给弹窗模块的prop=>params
 * @param init => {tit} tit: 弹窗标题
 * @param init => {Object} config: 弹窗配置=>看dialogConfig
 * @param init => {String} fromType: 弹窗类型：Add View Edit
 * @param init => {Object} propsData: 组件自定义标签值：弹窗自定义属性值例如 personId:xxx 接受方式在component组件内自定义prop personId
 * */
export default {
  name: 'CommonModal',
  data () {
    return {
      mode: '',
      open: false,
      title: '',
      fromType: '',
      propsData: {},//弹窗自定义属性值例如 personId:xxx 接受方式在component组件内自定义prop personId
      dialogConfig: {
        noPadding: false, // body是否需要内间距
        width: '60%', //弹窗宽度
        draggable: true, //为 Dialog 启用可拖拽功能
        modal: true, //是否需要遮罩层
        modalClass: '', //遮罩的自定义类名
        appendToBody: true, //Dialog 自身是否插入至 body 元素上。 嵌套的 Dialog 必须指定该属性并赋值为 true
        top: '15vh', //dialog CSS 中的 margin-top 值，默认为 15vh
        fullscreen: false, //是否为全屏 Dialog
        lockScroll: true, //是否在 Dialog 出现时将 body 滚动锁定
        customClass: '', //Dialog 的自定义类名
        openDelay: '', // dialog 打开的延时时间，单位毫秒
        closeDelay: '', //drawer 关闭的延时时间，单位毫秒
        closeOnClickModal: false, //是否可以通过点击 modal 关闭 Dialog
        closeOnPressEscape: false, //是否可以通过按下 ESC 关闭 Dialog
        showClose: true, //是否显示关闭按钮
        center: false, //是否让 Dialog 的 header 和 footer 部分居中排列
        alignCenter: false, //是否水平垂直对齐对话框 2.2.16版本
        destroyOnClose: false, //当关闭 Dialog 时，销毁其中的元素
        // closeIcon:'Close', //自定义关闭图标，默认 Close
        zIndex: '', //和原生的 CSS 的 z-index 相同，改变 z 轴的顺序
      }
    }
  },
  methods: {
    getTitle (title) {
      const f = {
        'View': '查看',
        'Edit': '编辑',
        'Add': '新增'
      }
      return f[title] ? f[title] : title
    },
    /**
     * 对象解构方式传递参数
     * @param modeVal 模板vue
     * @param tit 标题
     * @param config 弹窗配置
     * @param fromType 弹窗类型
     * @param propsData 传递给组件的参数
     */
    init ({ modeVal = null, tit = '', config = {}, fromType = null, propsData = {}}) {
      this.dialogConfig = Object.assign(this.dialogConfig, config);
      this.propsData = Object.assign(this.propsData, propsData);
      this.mode = modeVal;
      this.fromType = fromType;
      this.title = tit;
      this.open = true;
    },

    cancel () {
      this.open = false
    },
    // 子组件通知父组件关闭弹窗 并刷新父组件
    refresh (e) {
      this.$emit('refresh',e)
      this.cancel()
    },
    //  子组件通知父组件关闭弹窗 并返回参数给父组件
    backProp (e) {
      this.$emit('backProp', e)
      this.cancel()
    },
    /**
     *  设置标题
     * @param title
     */
    setTitle(title = this.title) {
      this.title = title
    }
  }
}
</script>

<style scoped>
.el-dialog {
  margin: 0 auto 10px;
  background: transparent;
}
.el-dialog ::v-deep .el-dialog__header {
  background: #1781b5;
  border-radius: 6px 6px 0px 0px;
}
.el-dialog ::v-deep .el-dialog__header .el-dialog__title {
  color: #fff;
}
.el-dialog ::v-deep .el-dialog__header .el-dialog__close {
  color: #fff;
}
.el-dialog__body {
  padding-top: 10px;
  background: #fff;
}
.set-body ::v-deep .el-dialog__body {
  padding: 30px 20px;
}
.nop-body /deep/ .el-dialog__body {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/commonModal/index.vue